import { autoinject, bindable } from 'aurelia-framework';
import { TableHeader } from 'components/table/table-content';
import { DialogService } from 'aurelia-dialog';
import { PenSegmentDialog } from '../pen-segment-dialog';
import { PenDimensionPipeSegmentService } from 'services/pen/pen-dimension-pipe-segment-service';
import { AsyncErrorHandler } from 'lib/ui';
import { PenDto } from 'models/pen/Pen';
import { PenService } from 'services/pen/pen-service';
import { PenDimensionDto } from 'models/pen/PenDimension';
import { PenDimensionService } from 'services/pen/pen-dimension-service';
import { PenDimensionPipeSegment } from 'models/pen/PenDimensionPipeSegment';
import { PubSub } from 'lib/event/PubSub';
import { PenDimensionPipeSegmentCreate } from '../pen-dimension-pipe-segment-create';
@autoinject
export class PenProductionContainer {
  @bindable
  protected penId: number;
  protected pen: PenDto;
  protected penDimension: PenDimensionDto;

  protected isLoading: boolean = false;

  protected hasInnerPipe: boolean = false;
  protected hasOuterPipe: boolean = false;
  protected hasBottomRing: boolean = false;
  protected hasFirstMiddlePipe: boolean = false;
  protected hasSecondMiddlePipe: boolean = false;

  protected tableDataInner: PenDimensionPipeSegment[] = [];
  protected tableDataOuter: PenDimensionPipeSegment[] = [];
  protected tableDataBottomRing: PenDimensionPipeSegment[] = [];
  protected tableDataFirstMiddle: PenDimensionPipeSegment[] = [];
  protected tableDataSeconMiddle: PenDimensionPipeSegment[] = [];

  protected innerPipeExpanded: boolean = false;
  protected outerPipeExpanded: boolean = false;
  protected bottomRingPipeExpanded: boolean = false;
  protected firstMiddlePipeExpanded: boolean = false;
  protected secondMiddlePipeExpanded: boolean = false;

  protected doneInnerPipeCount: number = 0;
  protected doneOuterPipeCount: number = 0;
  protected doneBottomRingPipeCount: number = 0;
  protected doneFirstMiddlePipeCount: number = 0;
  protected doneSecondMiddlePipeCount: number = 0;

  protected doneInnerPipeList: { isDone: boolean; index: number; lastItemIsDone?: boolean }[] = [];
  protected doneOuterPipeList: { isDone: boolean; index: number; lastItemIsDone?: boolean }[] = [];
  protected doneBottomRingPipeList: { isDone: boolean; index: number; lastItemIsDone?: boolean }[] = [];
  protected doneFirstMiddlePipeList: { isDone: boolean; index: number; lastItemIsDone?: boolean }[] = [];
  protected doneSecondMiddlePipeList: { isDone: boolean; index: number; lastItemIsDone?: boolean }[] = [];

  protected tableHeaders: TableHeader<any>[] = [
    { key: '', label: 'pens.segmentNr', sortable: true },
    { key: '', label: 'pens.weld', sortable: true },
    { key: '', label: 'general.date', sortable: true },
    { key: '', label: 'pens.hasBulkHead', sortable: true },
    { key: '', label: 'pens.bulkHeadWeldNo', sortable: true },
    { key: '', label: 'pens.weldTemp', sortable: true },
    { key: '', label: 'pens.joiningPressure', sortable: true },
    { key: '', label: 'pens.totalFusionPressure', sortable: true },
    { key: '', label: 'pens.heatingTimeWithPressure', sortable: true },
    { key: '', label: 'pens.heatingTimeWithoutPressure', sortable: true },
    { key: '', label: 'pens.changeOverTime', sortable: true },
    { key: '', label: 'pens.beadWidth', sortable: true },
    { key: '', label: 'pens.plateTempMeasured', sortable: true },
    { key: '', label: 'pens.dragPressure', sortable: true },
    { key: '', label: 'pens.coolDownTimeWithPressure', sortable: true },
    { key: '', label: 'pens.welder', sortable: true },
    { key: '', label: 'pens.supervisor', sortable: true },
    { key: '', label: 'general.status', sortable: true },
    { key: '', label: '', sortable: false },
  ];

  constructor(
    private dialogService: DialogService,
    private penService: PenService,
    private penDimensionService: PenDimensionService,
    private penDimensionPipeSegmentService: PenDimensionPipeSegmentService,
    private pubsub: PubSub
  ) {
    this.pubsub.sub('list-entity:updated', () => {
      void this.getPenDimensionPipeSegments();
    });
  }

  protected async attached() {
    await this.getPen(this.penId);
    await this.getPenDimension(this.pen.PenDimensionId);
    await this.getPenDimensionPipeSegments();
  }

  @AsyncErrorHandler
  async getPenDimensionPipeSegments() {
    this.isLoading = true;
    for (const penDimensionPipe of this.penDimension.PenDimensionPipes) {
      if (penDimensionPipe.Placement === 1) {
        this.hasInnerPipe = true;
        const inner = await this.penDimensionPipeSegmentService.getPenDimensionPipeSegments(
          this.penDimension.PenDimensionPipes.find((x) => x.Placement === 1).Id
        );
        this.tableDataInner = inner.data;
        this.doneInnerPipeList = [];
        this.tableDataInner.forEach((x) => {
          if (x.PenDimensionPipeSegmentStatusId === 3 || x.PenDimensionPipeSegmentStatusId === 4) {
            this.doneInnerPipeList.push({
              isDone: true,
              index: x.Index,
              lastItemIsDone:
                x.Index === 1 &&
                (this.tableDataInner[this.tableDataInner.length - 1].PenDimensionPipeSegmentStatusId === 3 ||
                  this.tableDataInner[this.tableDataInner.length - 1].PenDimensionPipeSegmentStatusId === 4)
                  ? true
                  : false,
            });
          } else {
            this.doneInnerPipeList.push({ isDone: false, index: x.Index });
          }
        });
        this.doneInnerPipeCount = this.doneInnerPipeList.filter((b) => b.isDone).length;
      }

      if (penDimensionPipe.Placement === 2) {
        this.hasOuterPipe = true;
        const outer = await this.penDimensionPipeSegmentService.getPenDimensionPipeSegments(
          this.penDimension.PenDimensionPipes.find((x) => x.Placement === 2).Id
        );
        this.tableDataOuter = outer.data;
        this.doneOuterPipeList = [];
        this.tableDataOuter.forEach((x) => {
          if (x.PenDimensionPipeSegmentStatusId === 3 || x.PenDimensionPipeSegmentStatusId === 4) {
            this.doneOuterPipeList.push({
              isDone: true,
              index: x.Index,
              lastItemIsDone:
                x.Index === 1 &&
                (this.tableDataOuter[this.tableDataOuter.length - 1].PenDimensionPipeSegmentStatusId === 3 ||
                  this.tableDataOuter[this.tableDataOuter.length - 1].PenDimensionPipeSegmentStatusId === 4)
                  ? true
                  : false,
            });
          } else {
            this.doneOuterPipeList.push({ isDone: false, index: x.Index });
          }
        });
        this.doneOuterPipeCount = this.doneOuterPipeList.filter((b) => b.isDone).length;
      }

      if (penDimensionPipe.Placement === 0) {
        this.hasBottomRing = true;
        const bottomRing = await this.penDimensionPipeSegmentService.getPenDimensionPipeSegments(
          this.penDimension.PenDimensionPipes.find((x) => x.Placement === 0).Id
        );
        this.tableDataBottomRing = bottomRing.data;
        this.doneBottomRingPipeList = [];
        this.tableDataBottomRing.forEach((x) => {
          if (x.PenDimensionPipeSegmentStatusId === 3 || x.PenDimensionPipeSegmentStatusId === 4) {
            this.doneBottomRingPipeList.push({
              isDone: true,
              index: x.Index,
              lastItemIsDone:
                x.Index === 1 &&
                (this.tableDataBottomRing[this.tableDataBottomRing.length - 1].PenDimensionPipeSegmentStatusId === 3 ||
                  this.tableDataBottomRing[this.tableDataBottomRing.length - 1].PenDimensionPipeSegmentStatusId === 4)
                  ? true
                  : false,
            });
          } else {
            this.doneBottomRingPipeList.push({ isDone: false, index: x.Index });
          }
        });
        this.doneBottomRingPipeCount = this.doneBottomRingPipeList.filter((b) => b.isDone).length;
      }

      if (penDimensionPipe.Placement === 3) {
        this.hasFirstMiddlePipe = true;
        const firstMiddle = await this.penDimensionPipeSegmentService.getPenDimensionPipeSegments(
          this.penDimension.PenDimensionPipes.find((x) => x.Placement === 3).Id
        );
        this.tableDataFirstMiddle = firstMiddle.data;
        this.doneFirstMiddlePipeList = [];
        this.tableDataFirstMiddle.forEach((x) => {
          if (x.PenDimensionPipeSegmentStatusId === 3 || x.PenDimensionPipeSegmentStatusId === 4) {
            this.doneFirstMiddlePipeList.push({
              isDone: true,
              index: x.Index,
              lastItemIsDone:
                x.Index === 1 &&
                (this.tableDataFirstMiddle[this.tableDataFirstMiddle.length - 1].PenDimensionPipeSegmentStatusId === 3 ||
                  this.tableDataFirstMiddle[this.tableDataFirstMiddle.length - 1].PenDimensionPipeSegmentStatusId === 4)
                  ? true
                  : false,
            });
          } else {
            this.doneFirstMiddlePipeList.push({ isDone: false, index: x.Index });
          }
        });
        this.doneFirstMiddlePipeCount = this.doneFirstMiddlePipeList.filter((b) => b.isDone).length;
      }

      if (penDimensionPipe.Placement === 4) {
        this.hasSecondMiddlePipe = true;
        const secondMiddle = await this.penDimensionPipeSegmentService.getPenDimensionPipeSegments(
          this.penDimension.PenDimensionPipes.find((x) => x.Placement === 4).Id
        );
        this.tableDataSeconMiddle = secondMiddle.data;
        this.doneSecondMiddlePipeList = [];
        this.tableDataSeconMiddle.forEach((x) => {
          if (x.PenDimensionPipeSegmentStatusId === 3 || x.PenDimensionPipeSegmentStatusId === 4) {
            this.doneSecondMiddlePipeList.push({
              isDone: true,
              index: x.Index,
              lastItemIsDone:
                x.Index === 1 &&
                (this.tableDataSeconMiddle[this.tableDataSeconMiddle.length - 1].PenDimensionPipeSegmentStatusId === 3 ||
                  this.tableDataSeconMiddle[this.tableDataSeconMiddle.length - 1].PenDimensionPipeSegmentStatusId === 4)
                  ? true
                  : false,
            });
          } else {
            this.doneSecondMiddlePipeList.push({ isDone: false, index: x.Index });
          }
        });
        this.doneSecondMiddlePipeCount = this.doneSecondMiddlePipeList.filter((b) => b.isDone).length;
      }
      this.isLoading = false;
    }
  }

  @AsyncErrorHandler
  async getPenDimensionPipeSegment(id: number) {
    return await this.penDimensionPipeSegmentService.getPenDimensionPipeSegments(id);
  }

  @AsyncErrorHandler
  async getPenDimension(id: number) {
    const { data } = await this.penDimensionService.getPenDimension(id);
    this.penDimension = data;
  }

  @AsyncErrorHandler
  async getPen(id: number) {
    const { data } = await this.penService.getPen(id);
    this.pen = data;
  }

  protected editSegment(id: number, pipeList: any) {
    void this.dialogService
      .open({
        viewModel: PenSegmentDialog,
        model: {
          penDimensionPipeSegmentId: id,
          pipeList: pipeList,
        },
        position: () => {
          return {
            top: 0,
          };
        },
      })
      .whenClosed(() => {
        document.querySelector('html').style.overflowY = null;
        this.getPenDimensionPipeSegments();
      });
  }

  protected createSegment(penDimensionPipeSegmentData: PenDimensionPipeSegment[]) {
    void this.dialogService
      .open({
        viewModel: PenDimensionPipeSegmentCreate,
        model: {
          data: penDimensionPipeSegmentData,
        },
      })
      .whenClosed(() => {
        document.querySelector('html').style.overflowY = null;
        this.getPenDimensionPipeSegments();
      });
  }

  protected hideInnerPipeTableExpand() {
    this.innerPipeExpanded = true;
    const table = document.getElementById('innerPipeTable');
    if (table) {
      table.style.visibility = 'collapse';
    }
  }

  protected showInnerPipeTableExpand() {
    this.innerPipeExpanded = false;
    const table = document.getElementById('innerPipeTable');
    if (table) {
      table.style.visibility = 'visible';
    }
  }

  protected hideOuterPipeTableExpand() {
    this.outerPipeExpanded = true;
    const table = document.getElementById('outerPipeTable');
    if (table) {
      table.style.visibility = 'collapse';
    }
  }

  protected showOuterPipeTableExpand() {
    this.outerPipeExpanded = false;
    const table = document.getElementById('outerPipeTable');
    if (table) {
      table.style.visibility = 'visible';
    }
  }

  protected hideBottomRingPipeTableExpand() {
    this.bottomRingPipeExpanded = true;
    const table = document.getElementById('bottomRingPipeTable');
    if (table) {
      table.style.visibility = 'collapse';
    }
  }

  protected showBottomRingPipeTableExpand() {
    this.bottomRingPipeExpanded = false;
    const table = document.getElementById('bottomRingPipeTable');
    if (table) {
      table.style.visibility = 'visible';
    }
  }

  protected hideFirstMiddlePipeTableExpand() {
    this.firstMiddlePipeExpanded = true;
    const table = document.getElementById('firstMiddlePipeTable');
    if (table) {
      table.style.visibility = 'collapse';
    }
  }

  protected showFirstMiddlePipeTableExpand() {
    this.firstMiddlePipeExpanded = false;
    const table = document.getElementById('firstMiddlePipeTable');
    if (table) {
      table.style.visibility = 'visible';
    }
  }

  protected hideSecondMiddlePipeTableExpand() {
    this.secondMiddlePipeExpanded = true;
    const table = document.getElementById('secondMiddlePipeTable');
    if (table) {
      table.style.visibility = 'collapse';
    }
  }

  protected showSecondMiddlePipeTableExpand() {
    this.secondMiddlePipeExpanded = false;
    const table = document.getElementById('secondMiddlePipeTable');
    if (table) {
      table.style.visibility = 'visible';
    }
  }
}
